module.exports = __webpack_public_path__ + "img/珍珠.57c98427.jpg";